import React from "react"

import { Date as DateField } from "@tenforce/product-fields"

import { useAppSelector } from "../../../../../hooks"

import { Labels } from "../../../../../util/Translations"

import {
    getLocale,
    getTimeZoneForLuxon,
} from "../../../../applicationheader/components/usermenu/selector"

import { ICheckListViewActions, IQuestion } from "../../.."
import { GlobalState } from "../../../../../store"

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const DateFieldValue = ({
    data,
    id,
    contextMenuActions: { updateSimpleValue },
    controls: { canEditValue },
}: Props): JSX.Element => {
    const currentValue = data as string

    const timeZone = useAppSelector((state) =>
        getTimeZoneForLuxon(state.userInfo),
    )
    const locale = useAppSelector((state) => getLocale(state.userInfo))
    const { cultureUI } = useAppSelector((state: GlobalState) => state.userInfo)

    return (
        <DateField
            shouldHighlightIfDatePassed={false}
            shouldShowTimeComponent={false}
            value={currentValue}
            locale={locale}
            timeZone={timeZone}
            culture={cultureUI}
            fieldId="dateAnswer"
            isLoading={false}
            onSave={(value: string): void => {
                updateSimpleValue(id, value)
            }}
            isReadOnly={!canEditValue}
            labels={{
                PleaseEnterAValidDate: `${Labels.PleaseEnterAValidDateFormat} ${
                    locale === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
                }`,
            }}
            placeholder={Labels.ClickHereToEdit}
        />
    )
}

export default DateFieldValue
